import { z } from "zod";

const contentItemSchema = z.object({
  text: z.string().optional(),
  type: z.enum(["text", "file", "button", "offers"]),
  style: z
    .record(z.string(), z.union([z.string(), z.number()]))
    .nullable()
    .optional(),
  status: z.enum(["info", "success", "error", "warning"]).nullable().optional(),
  button_text: z.string().optional(),
  button_redirect_type: z
    .enum(["redirect_link", "calendar_link", "resume_link", "restart_application"])
    .optional(),
  button_url: z.string().optional(),
  resume_product_type: z.number().optional(),
});

export type MessageItem = z.infer<typeof contentItemSchema>;

export const messageSchema = z.object({
  content: z.array(contentItemSchema).optional(),
  context: z.enum(["borrower_platform"]).optional(),
  state: z.string().optional(),
  version: z.string(),
});

export type Message = z.infer<typeof messageSchema>;
